import {createReducer} from '@reduxjs/toolkit';

import {setExpiringPointsAction} from 'store/actions/campaign-action';
import {ReduxCampaignState} from 'types/campaign';

const initialState: ReduxCampaignState = {};

// HY TODO: move all other campaign related items here to reduce bloating the basket
const CampaignReducer = createReducer(initialState, (builder) => {
  builder.addCase(setExpiringPointsAction, (state, action) => {
    return {
      ...state,
      expiringPoints: action?.payload
    };
  });
});

export default CampaignReducer;
